var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5969 10.7295L12.8289 0.917765C12.3563 0.487031 11.6435 0.487078 11.1711 0.917718L0.403033 10.7296C0.0244239 11.0746 -0.100638 11.6061 0.08433 12.0837C0.269345 12.5614 0.719813 12.8699 1.23202 12.8699H2.95186V22.7006C2.95186 23.0903 3.26789 23.4064 3.65765 23.4064H9.55986C9.94963 23.4064 10.2657 23.0904 10.2657 22.7006V16.7317H13.7345V22.7006C13.7345 23.0904 14.0505 23.4064 14.4403 23.4064H20.3422C20.732 23.4064 21.048 23.0904 21.048 22.7006V12.8699H22.7682C23.2803 12.8699 23.7308 12.5613 23.9159 12.0837C24.1006 11.6061 23.9755 11.0746 23.5969 10.7295Z",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4b0c5302c71098b99a16fd746fc3e078.svg";
export { ForwardRef as ReactComponent };